module.exports = __webpack_public_path__ + "img/image.17ee9034.svg";